import PropTypes from 'prop-types';
export const detailsPropTypes = {
  /**
   * Category content: label and href
   */
  category: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string
  }),
  /**
   * Date of publish - MMM DD
   */
  date: PropTypes.string,
  /**
   * If true Details width is auto, if false it's max-width set to 64px
   */
  isLarge: PropTypes.bool
};